<template>
    <div
        :class="['visual-compass', modify]"
        :style="{transform: `rotate(${compass.deg}deg)`}"
    >
        <div class="visual-compass__circle">
            <iconCompass className="visual-compass__svg" />
        </div>
        <div class="visual-compass__rose">
            <span class="visual-compass__rose-item"
                  :style="{transform: `rotate(${-compass.deg}deg)`}">C
            </span>
            <span class="visual-compass__rose-item"
                  :style="{transform: `rotate(${-compass.deg}deg)`}">Ю
            </span>
        </div>
    </div>
</template>

<style lang='scss'>
    @import "Compass";
</style>

<script>
import iconCompass from '../Icons/icon-compass.vue';
import {mapGetters} from 'vuex';

export default {
    props: ['modify'],

    components: {iconCompass},

    computed: {
        ...mapGetters({
            compass: 'GET_COMPASS',
            views  : 'GET_VIEWS'
        })
    }
};
</script>

